import type { CustomTheme } from '.'

export const customTheme: CustomTheme = {
  colors: {
    primary: {
      DEFAULT: '#008b90',
      '50': '#f1f9f9',
      '100': '#c8e6e7',
      '200': '#96d0d2',
      '300': '#58b4b7',
      '400': '#33a3a7',
      '500': '#008b90',
      '600': '#00757a',
      '700': '#005e62',
      '800': '#005053',
      '900': '#003a3c',
    },
  },
}
